import { useReducer, useEffect } from "react";
import "../Lightcast.scss";

import { sendRequest } from "../../../common/http";
import BottomGrowingIndustries from "./BottomGrowingIndustries";
import TopGrowingIndustries from "./TopGrowingIndustries";
import translate from "@/i18n/translate";
import { IndustryOrOccupation, IndustriesOrOccupations } from "../Interface";

interface IndustriesState {
  bottomGrowingIndustries: null | IndustryOrOccupation[];
  topGrowingIndustries: null | IndustryOrOccupation[];
  loader: boolean;
  apiError: boolean;
}

const defaultIndustriesOrOccupations = {
  top: [],
  bottom: []
};

const defaultIndustriesAction = {
  type: "",
  data: defaultIndustriesOrOccupations
};

interface IndustriesAction {
  type: string;
  data: IndustriesOrOccupations;
}

const initialState = {
  bottomGrowingIndustries: null,
  topGrowingIndustries: null,
  loader: true,
  apiError: false
};

const reducer = (state: IndustriesState, action: IndustriesAction) => {
  switch (action.type) {
    case "setIndustries":
      return {
        ...state,
        bottomGrowingIndustries: action.data?.bottom,
        topGrowingIndustries: action.data?.top,
        loader: false
      };
    case "setIndustriesError":
      return {
        ...state,
        bottomGrowingIndustries: null,
        topGrowingIndustries: null,
        loader: false,
        apiError: true
      };
    default:
      return state;
  }
};

export interface IndustriesProps {
  onComponentLoad: (component: string) => void;
}

export default function Industries({ onComponentLoad }: IndustriesProps) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const applyResult = (result: IndustriesOrOccupations) => {
      dispatch({ type: "setIndustries", data: result });
      onComponentLoad("industries");
    };

    const onError = (error: any) => {
      dispatch({ ...defaultIndustriesAction, type: "setIndustriesError" });
    };

    sendRequest(
      { uri: "/lightcast/industries", camelize: true },
      applyResult,
      onError
    );
  }, []);
  return (
    <div className="grid-container wm-grid-col-12 wm-grid-col-lg-12 wm-grid-col-md-10 wm-grid-col-sm-8">
      <div className="industries-occupations-label">
        {translate("app.lightcast.industriesLabel")}
      </div>
      <div className="wm-grid-row">
        <div className="grid-container wm-grid-col-6 wm-grid-col-xl-6 wm-grid-col-lg-6 wm-grid-col-md-10 wm-grid-col-sm-8 -min-width">
          <BottomGrowingIndustries
            industries={state.bottomGrowingIndustries}
            loader={state.loader}
          />
        </div>
        <div className="grid-container wm-grid-col-6 wm-grid-col-xl-6 wm-grid-col-lg-6 wm-grid-col-md-10 wm-grid-col-sm-8 -min-width">
          <TopGrowingIndustries
            industries={state.topGrowingIndustries}
            loader={state.loader}
          />
        </div>
      </div>
    </div>
  );
}
